module.exports = __webpack_public_path__ + "media/images/tailwind/close-icon-4d4c699f398e749eee5316ffb0ffb5e5.png";